<script setup lang="ts">
/**
 * Final Dividends — Notice (Sole Corporate Member, 서면결의 by written means).
 *   원본: Notice – Final Dividends (Sole Corporate Member).
 *   서명 = By Order Of The Board, 이사 1인([[Signing_Director_Signature]]).
 *   반송 이메일은 CSP 이메일([[CSP_Email]]).
 */
import CddVarField from '../cdd/CddVarField.vue';
import AgmSigners from '../cdd/AgmSigners.vue';
import './agmDoc.css';
</script>

<template>
  <div class="agm-doc">
    <div class="doc-head">
      <div><b><CddVarField field-key="company_name" label="Company Name" /></b></div>
      <div>Company Registration No. <CddVarField field-key="company_registration_no" label="Reg No" /></div>
      <div>(Incorporated in the Republic of Singapore)</div>
      <div>(the &ldquo;Company&rdquo;)</div>
      <div>Registered Office: <CddVarField field-key="registered_office_address" label="Registered Office Address" /></div>
    </div>

    <div class="doc-title">NOTICE</div>
    <p class="doc-p">
      NOTICE IS HEREBY GIVEN for the purpose of considering and, if thought fit, passing with or without amendments,
      the following ordinary resolutions by written means: -
    </p>

    <div class="sec-title">FINAL DIVIDEND</div>
    <p class="doc-p">
      NOTED THAT the Company has sufficient profits for the declaration of a final dividend of
      <CddVarField field-key="dividend_amount" label="Dividend Amount" /> to its member.
    </p>
    <p class="doc-p">
      RESOLVED THAT a final one-tier tax exempt dividend of <CddVarField field-key="dividend_amount" label="Dividend Amount" />
      in respect of the financial year ended <CddVarField field-key="financial_year_end" label="Financial Year End" />
      and is hereby approved for payment out of the profits of the Company to the member whose names appear on the Register of Members.
    </p>

    <p class="doc-p">BY ORDER OF THE BOARD</p>
    <div class="sign-block">
      <AgmSigners var-key="signing_director_Signers" board-label="Director" />
    </div>
    <p class="doc-p">Dated: <CddVarField field-key="notice_date" label="Notice Date" /></p>

    <p class="doc-p">
      If you, being a member of the Company, agree to the above resolutions, please sign the attached member&rsquo;s resolutions in
      writing. Thereafter, please email resolutions to the below email address and return the original to the Company at the below
      registered office address.
    </p>
    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-lcell">Address</td><td><CddVarField field-key="registered_office_address" label="Registered Office Address" /></td></tr>
        <tr><td class="cdd-lcell">Email</td><td><CddVarField field-key="csp_email" label="CSP / Return Email" /></td></tr>
      </tbody>
    </table>
  </div>
</template>
